/* eslint-disable radix */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from '~/styles/pagesStyle';
import { handleRegisterGroup } from '../GruposServices';
import CadastroGrupoCard from './CadastroGrupoCard';

const initialForm = {};

function GrupoCadastro() {
  const [form, setForm] = useState(initialForm);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const date = new Date().toISOString();
  const userLogged = sessionStorage.getItem('@auth/userName');

  async function handleSubmit(event) {
    if (!form.idPessoaEmpresa) {
      toast.error('Empresa é obrigatório');
      return;
    }
    if (!form.groupName) {
      toast.error('Nome do grupo é obrigatório');
      return;
    }
    if (!form.situacaoCadastral) {
      toast.error('Situação Cadastral é obrigatório');
      return;
    }
    event.preventDefault();
    const grupo = {
      id: 0,
      idPessoaEmpresa: form.idPessoaEmpresa,
      idSituacaoCadastral: form.situacaoCadastral,
      nome: form.groupName,
      dataInclusao: date,
      usuario: userLogged,
      excluido: false,
      idsModulo: [],
    };
    setLoading(true);
    await handleRegisterGroup(grupo, setLoading);
    history.push('/group/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      <CadastroGrupoCard
        handleSubmit={handleSubmit}
        setForm={setForm}
        form={form}
        loading={loading}
      />
    </Container>
  );
}

export default GrupoCadastro;
